import { useState } from 'react';
import {
    Column,
    Item,
    Lookup
} from 'devextreme-react/data-grid';
import { useGetEstimates } from "../api/get-estimates";
import { ClosedOrdersChangedEvent } from '../../../common/closed-orders-control/types/CloseOrderProps';
import { Link, useLocation } from 'react-router-dom';
import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { EstimateGridProps } from '../types/EstimateGridProps';
import { ClosedOrdersControl } from '../../../common';
import OrderTypeSelector from '../../order-type-selector/components/OrderTypeSelector';
import { useAuth } from '../../../../contexts/auth';
import { useGetCompany } from '../../../../api/company';

export default function EstimateGrid(props: EstimateGridProps) {

    const { user } = useAuth();
    const company = useGetCompany(user?.companyId);

    let [closedOrdersState, setClosedOrdersState] = useState<{ closedOrders: boolean, dateFrom: Date | null }>
        ({ closedOrders: false, dateFrom: null });

    const estimates = useGetEstimates(closedOrdersState.closedOrders, closedOrdersState.dateFrom, props.leads);

    const location = useLocation();
    const returnUrl = encodeURIComponent(location.pathname + location.search);

    return (
        <div className='dx-card wide-card'>
            <OrderTypeSelector />
            <SyncDataGrid
                stateStorageKey={props.leads ? "lead-grid" : "estimate-grid"}
                dataSource={estimates.data?.estimates}
                keyExpr={'quoteID'}
                height="60vh"
                additionalToolbarItems={[
                    <Item
                        location={'before'}
                        key="closed-orders"
                    >
                        <ClosedOrdersControl
                            text={props.leads ? "Closed/Expired Leads" : "Closed/Expired Estimates"}
                            onClosedOrdersChanged={(e: ClosedOrdersChangedEvent) => {
                                setClosedOrdersState({ closedOrders: e.checked, dateFrom: e.dateFrom })
                            }}
                        />
                    </Item>
                ]}
            >
                <Column
                    dataField={'quoteNumber'}
                    caption={props.leads ? 'Lead #' : 'Estimate #'}
                    dataType="string"
                    cellRender={(cell: any) => {
                        return <Link to={`/cfi/estimate/${cell.data.quoteID}?returnUrl=${returnUrl}`}>
                            {cell.data.quoteNumber}
                        </Link>;
                    }}
                />
                <Column
                    dataField={'projectNumber'}
                    caption={'Project #'}
                    dataType="string"
                />
                <Column
                    dataField={'quoteDate'}
                    caption={props.leads ? 'Lead Date' : 'Estimate Date'}
                    dataType="date"
                />
                <Column
                    dataField={'dealerNumber'}
                    caption={'Store #'}
                    dataType="string"
                />
                <Column
                    dataField={'status'}
                    caption={'Status'}
                    dataType="string"
                >
                    <Lookup
                        dataSource={estimates.data?.statuses}
                    />
                </Column>
                <Column
                    dataField={'customerName'}
                    caption={'Customer Name'}
                    dataType="string"
                />
                <Column
                    dataField={'customerAddress'}
                    caption={'Customer Address'}
                    dataType="string"
                />
                <Column
                    dataField={'customerPhone'}
                    caption={'Customer Phone #'}
                    dataType="string"
                />
                <Column
                    dataField={'customerEmail'}
                    caption={'Customer Email'}
                    dataType="string"
                />
                <Column
                    dataField={'customerCityZip'}
                    caption={'City/State,Zip'}
                    dataType="string"
                />
                {
                    closedOrdersState.closedOrders && company.data?.SFI &&
                    <Column
                        dataField={'cSale'}
                        caption={'C-Sale'}
                        dataType="boolean"
                    />
                }
            </SyncDataGrid>

            <LoadPagePanel visible={estimates.isLoading} />

        </div>
    )
} 
